import {PolyDictionary} from '../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {AttribType, AttribSize} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Constant';
import {CoreEntity} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/CoreEntity';
import {ColDef, ColGroupDef} from 'ag-grid-community';

export function attribClassClassObject(state: boolean) {
	if (state) {
		return {
			'bg-black': true,
			'text-white': true,
		};
	} else {
		return {
			'bg-gray-800': true,
			'text-gray-600': true,
		};
	}
}

export type BuildHeaders = (
	attribNames: string[],
	attribSizesByName: PolyDictionary<AttribSize>,
	attribTypesByName: PolyDictionary<AttribType>
) => void;
export type BuildTableData = (
	entities: CoreEntity[],
	attrib_names: string[],
	attrib_sizes_by_name: PolyDictionary<AttribSize>
) => void;

export type ColDefsArray = (ColDef<any> | ColGroupDef<any>)[];
